import { SITE } from "@/data/site";

/* Bandeau de réassurance en défilement continu (marquee), fond navy.
   Contenu 100% réel et déjà utilisé ailleurs sur le site (chiffres,
   zone d'intervention, villes, téléphone) — aucun logo, aucune
   certification, aucun partenariat n'est affiché ici.
   TODO: si un badge RGE/Qualibat/assurance décennale visuel est un
   jour confirmé par le client, un emplacement pourra être ajouté ici.
   Ne rien afficher tant que ce n'est pas explicitement validé. */
const MARQUEE_ITEMS = [
  "10 ans d'expérience",
  "Garantie décennale",
  "Devis gratuit sous 48h",
  "Déplacement offert",
  "Dordogne · Lot · Corrèze · Haute-Vienne · Charente",
  "Périgueux",
  "Sarlat",
  "Bergerac",
  "Brive-la-Gaillarde",
  "Cahors",
  "Limoges",
  "Angoulême",
  SITE.phone,
];

export const Reassurance = () => (
  <section className="bg-brand-deep py-5 overflow-hidden" data-testid="reassurance-bar" aria-hidden="true">
    <div className="marquee-track">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center shrink-0">
          {MARQUEE_ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center whitespace-nowrap font-medium text-white/85 text-sm lg:text-[15px] px-6">
              {item}
              <span className="ml-6 w-1.5 h-1.5 rounded-full bg-brand-metallic inline-block" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
